import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LecturesComponent} from './lectures.component';
import {AddLectureComponent} from './add-lecture/add-lecture.component';

const routes: Routes = [
    {
        path: 'lectures',
        component: LecturesComponent,
        data: {animation: 'lectures'}
    },
    {
        path: 'lectures/add',
        component: AddLectureComponent,
        data: {animation: 'lectures/add'}
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class LecturesRoutingModule {
}
